import { useLayoutEffect } from 'react';
import { ENV_MODE } from '../../constants';

const useGoogleAnalytics = () => {
    useLayoutEffect(() => {
        if (ENV_MODE === 'production') {
            // Create script 1 with url
            const script1 = document.createElement('script');
            script1.async = true;
            script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-7XR44MMQQ8';

            // Create script 2 with inline content
            const script2 = document.createElement('script');
            script2.textContent = `
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                window.dataLayer.push(arguments);
                }
                gtag('js', new Date());
                gtag('config', 'G-7XR44MMQQ8');
            `;

            document.body.appendChild(script1);
            document.body.appendChild(script2);

            return () => {
                document.body.removeChild(script1);
                document.body.removeChild(script2);
            };
        }
    }, []);

};

export default useGoogleAnalytics;
